import React, { useEffect } from "react";
import { Form, FormControl } from "react-bootstrap";
import TooltipText from "../TooltipText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { fixNumber } from "../../utils/utils";
import { RecursosComercios } from "../../constants";

const SelectPlan = ({ recurso, imponible, handleShowModal, handleCuotas, setTipoPlan, tipoPlan, setAnticipo, anticipo, contado, total }) => {
  const monto_6_cuotas = 500000;

  useEffect(() => {
    if (total < monto_6_cuotas && tipoPlan[recurso + "-" + imponible] === "W2203") {
      setTipoPlan({ ...tipoPlan, [recurso + "-" + imponible]: "W2200" });
    }
    else if (total > monto_6_cuotas && tipoPlan[recurso + "-" + imponible] === "W2200") {
      setTipoPlan({ ...tipoPlan, [recurso + "-" + imponible]: "W2203" });
    }

    if (total < monto_6_cuotas && tipoPlan[recurso + "-" + imponible] === "W2113") {
      setTipoPlan({ ...tipoPlan, [recurso + "-" + imponible]: "W2112" });
    }
    else if (total > monto_6_cuotas && tipoPlan[recurso + "-" + imponible] === "W2112") {
      setTipoPlan({ ...tipoPlan, [recurso + "-" + imponible]: "W2113" });
    }
  }, [total]);

  useEffect(() => {
    setAnticipo({ ...anticipo, [recurso + "-" + imponible]: fixNumber(total * 0.30) });
  }, [total]);


  const handleSelect = (e) => {
    setTipoPlan({ ...tipoPlan, [recurso + "-" + imponible]: e.target.value });
  };

  return (
    <div className="d-flex flex-column justify-content-end">
      <div className="text-center my-3">
        <span>Tipo de plan</span>
      </div>
      <div className="d-flex justify-content-center align-items-center mb-2">
        <div className="ml-2">
          <FormControl
            as={"select"}
            onChange={handleSelect}
            value={tipoPlan[recurso + "-" + imponible] || ""}
            disabled={contado && contado[recurso + "-" + imponible]}
          >
            <option value="">Seleccionar plan</option>

            {RecursosComercios.includes(recurso) ? (
              <>
                <option value="SHCON">Comercios - 1 Cuota</option>
                <option value="SHANT_6">Comercios - 6 cuotas con intereses</option>
                <option value="SHANT_12">Comercios - 12 cuotas con intereses</option>
              </>
            ) : (
              <>
                <option value="ABLT">Inmuebles - Cuotas con intereses</option>
                {/* <option value="ABLT_7">7 cuotas con interes</option>
                    <option value="ABLT_8">8 cuotas con interes</option>
                    <option value="ABLT_9">9 cuotas con interes</option>
                    <option value="ABLT_10">10 cuotas con interes</option>
                    <option value="ABLT_11">11 cuotas con interes</option>
                    <option value="ABLT_12">12 cuotas con interes</option> */}
                <option value="W2112">Inmuebles - 3 cuotas sin interes</option>
                <option value="W2113">Inmuebles - 6 cuotas sin interes</option>
                <option value="W2201">Inmuebles - 1 cuota c/quita 20% de intereses</option>
                {/* <option value="W2202">Inmuebles - 1 pago con 20% descuento sobre los intereses</option> */}

                {/* <option value="W2200">Inmuebles - Anticipo y 3 cuotas</option>
                {<option value="W2203">Inmuebles - Anticipo y 6 cuotas</option>} */}
              </>
            )
            }
          </FormControl>
        </div>
        {/* <div className="ml-2">
          <div className="text-left my-2">
            <FormLabel>Para Comercios:</FormLabel>
          </div>
          <FormControl
            as={"select"}
            onChange={(e) => {
              setTipoPlan({ ...tipoPlan, [recurso + "-" + imponible]: e.target.value });
            }}
            value={tipoPlan[recurso + "-" + imponible] || ""}
            disabled={contado && contado[recurso + "-" + imponible]}
          >
            <option value="">Seleccionar plan</option>
            <option value="SHANT">Cuotas con intereses</option>
            <option value="SHANT">Cuotas con intereses</option>
          </FormControl>
        </div> */}
        {tipoPlan[recurso + "-" + imponible] === "W2203" || tipoPlan[recurso + "-" + imponible] === "W2200" ? (
          <div className="d-flex align-items-center ml-3">
            <span>Anticipo</span>
            <div className="ml-2">
              <FormControl
                style={{ maxWidth: 150 }}
                // onChange={(e) => setAnticipo({ ...anticipo, [recurso + "-" + imponible]: e.target.value })}
                value={anticipo[recurso + "-" + imponible]}
                disabled
              />
            </div>
          </div>
        ) : null}

        <div className="d-flex justify-content-end align-items-center ml-3">
          {!tipoPlan[recurso + "-" + imponible] || tipoPlan[recurso + "-" + imponible] === "ABLT" ? (
            <div className="d-flex align-items-center">
              Plan de Pago en
              <Form.Control
                name={recurso + "-" + imponible}
                defaultValue={15}
                min={1}
                className="mx-2"
                style={{ width: 80 }}
                onChange={handleCuotas}
                disabled={contado && contado[recurso + "-" + imponible]}
              />
              cuotas
            </div>
          ) : null}

          <TooltipText placement="right" text="Ver cuotas" >
            <FontAwesomeIcon
              onClick={() => handleShowModal({ imponible, recurso })}
              icon={faEye}
              size="lg"
              className="ml-4"
            />
          </TooltipText>

        </div>
      </div>
    </div>
  );
};

export default SelectPlan;
